import { useCallback } from 'react';
import { useUpdateTicketSales as useUpdateSellableMutation } from '@api';
import { useNotification } from '@common';
import { useDebouncedCallback } from '@mantine/hooks';
import { AxiosError } from 'axios';

const TRANS_PATH_NOTIFICATION = 'NOTIFICATIONS.UPDATE_TICKET_SALES';
const UPDATE_SELLABLE_DEBOUNCE_MS = 500;

type UseUpdateSellableReturnType = {
  handleUpdateSellable: (
    ticketSalesId: string,
    ticketsSellable: number
  ) => void;
};

export const useUpdateSellable = (): UseUpdateSellableReturnType => {
  const { mutate } = useUpdateSellableMutation();
  const { showError } = useNotification();

  const updateSellable = useCallback(
    (ticketSalesId: string, ticketsSellable: number) => {
      mutate(
        {
          id: ticketSalesId,
          data: { ticketsSellable },
        },
        {
          onError: (error) => {
            showError({
              title: `${TRANS_PATH_NOTIFICATION}.ERROR.TITLE`,
              message: `${TRANS_PATH_NOTIFICATION}.ERROR.MESSAGE`,
              error: error as AxiosError,
            });
          },
        }
      );
    },
    [mutate, showError]
  );

  const handleUpdateSellable = useDebouncedCallback(
    updateSellable,
    UPDATE_SELLABLE_DEBOUNCE_MS
  );

  return { handleUpdateSellable };
};
